import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";
import { ChartHeader } from "./ChartHeader";
import { ChartArea } from "./ChartArea";
import { ChartBars } from "./ChartBars";
import { buildTrend } from "./trendData";

// ظل 3D للحاوية — بلا تغيير في السلوك، فقط عمق بصري.
const CHART_3D = {
  boxShadow:
    "0 14px 28px rgba(0,0,0,0.32), 0 8px 12px rgba(0,0,0,0.20),"
    + " inset 0 1.5px 0 rgba(255,255,255,0.28), inset 0 -4px 10px rgba(0,0,0,0.18)",
};

// منحنى الحضور: هيدر شارات + مبدّل عرض + رسم منطقة أو أعمدة.
export const AttendanceChart = ({ rows }) => {
  const { t } = useTranslation();
  const [mode, setMode] = useState("area");
  const { data, totals } = buildTrend(rows);

  return (
    <NeuCard data-testid="attendance-chart" style={CHART_3D}>
      <ChartHeader totals={totals} mode={mode} setMode={setMode} />
      <div className="-mx-5 mt-4 h-52 min-h-[208px] w-auto min-w-0 sm:mx-0 sm:mt-5 sm:h-72 sm:min-h-[288px] sm:w-full">
        {data.length === 0 ? (
          <p className="text-sm text-muted-foreground">{t("app.none")}</p>
        ) : mode === "area" ? (
          <ChartArea data={data} />
        ) : (
          <ChartBars data={data} />
        )}
      </div>
    </NeuCard>
  );
};
